import React, { useEffect, useState } from "react";
import { useAlert } from "react-alert";
import api from "../../seller-apis/api";
import servicesApi from "../../seller-apis/servicesApi";
import convertCsvFileToJsonArray from "../../utilities/convertFileToJsonArray";
import "./BulkUploadProd.css";
import { Popover, OverlayTrigger, Collapse } from "react-bootstrap";

function BulkUploadProd() {
  const [uploadStart, setUploadStart] = useState(false);
  const [uploadError, setUploadError] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadProdCount, setUploadProdCount] = useState(0);
  const [categories, setCategories] = useState([]);
  const [catNavToggleState, setCatNavToggleState] = useState("");
  const [subCatNavToggleState, setsubCatNavToggleState] = useState("");
  const [toggleCategory, setToggleCategory] = useState(false);
  const [categorySelected, setCategorySelected] = useState(false);
  const [selectedUploadCategory, setSelectedUploadCategory] = useState(null);
  const [finalCategoryArray, setFinalCategoryArray] = useState(null);
  // let categoriesId = [];
  const alert = useAlert();
  useEffect(async () => {
    const ress = await servicesApi.categories.categoryTree({});
    let catList = ress.data.subCategories;
    setCategories(catList);
  }, []);
  async function uploadData(e) {
    setUploadStart(true);
    const array = await convertCsvFileToJsonArray(e.target.files);
    // console.log("array: ", array);

    // return;
    let productData =[];
    for (let i = 0; i < array.length; i++) {
      // if (!array[i]["Category"]) {
      //   alert.info("Please add a category");
      //   return false;
      // }
      // else if (!array[i]["Image Link1"]) {
      //   alert.info("Please upload image link1.");
      //   return false;
      // } else if (!array[i]["Image Link2"]) {
      //   alert.info("Please upload image link2");
      //   return false;
      // }
      if (!array[i]["Product Name"]) {
        alert.info("Please enter a valid Product name");
        setCategorySelected(false);
        setUploadStart(false);
        setUploadError(false);
        setUploadSuccess(false);
        return false;
      }
      //  else if (!array[i]["Transfer Price"]) {
      //   alert.info("Please fill Transfer Price");
      //   return false;
      // } else if (!array[i]["GST%"]) {
      //   alert.info("Please add GST%");
      //   return false;
      // } else if (!array[i]["Description"]) {
      //   alert.info("Product add description");
      //   return false;
      // } else if (!array[i]["Meta Keywords"]) {
      //   alert.info("Please add Meta Keywords");
      //   return false;
      // } else if (!array[i]["Brand"]) {
      //   alert.info("Please add Brand");
      //   return false;
      // } else if (!array[i]["Video Link"]) {
      //   alert.info("Please add Video Link");
      //   return false;
      // } else if (!array[i]["Hsn"]) {
      //   alert.info("Please add HSN code");
      //   return false;
      // }

      const imgUrls = [];
      let keywords =[];
      // console.log(array);
      if(array[i]["Meta Keywords"]){
       keywords = array[i]["Meta Keywords"].split(",");
      }
      // let data1 = {
      //   baseImage: true,
      //   smallImage: false,
      //   thumbnail: false,
      //   visible: false,
      //   image: array[i]["Image Link1"],
      //   label: array[i]["Image Link1"],
      // };
      // imgUrls.push(data1);
      // let data2 = {
      //   baseImage: false,
      //   smallImage: false,
      //   thumbnail: false,
      //   visible: false,
      //   image: array[i]["Image Link2"],
      //   label: array[i]["Image Link2"],
      // }
      // imgUrls.push(data2);
      let brandid=0;
  if(array[i]['Brand'])
    {
      let brandData = await api.brand.getManufacturers( {"filter": { "name-id": array[i]['Brand']} } );
          brandData = brandData.data;
          console.log("branddata",brandData)
      brandid = brandData.length > 0 ? brandData[0].manufacturerId: 0;
    }
      const piData = {
        // images: imgUrls,
        description: array[i]["Description"],
        price: array[i]["Transfer Price"],
        taxClass: array[i]["GST%"],
        productName: array[i]["Product Name"],
        videos: [array[i]["Video Link"]],
        manufacturer: brandid,
        categories: finalCategoryArray,
        metaInformation: {
          keywords: keywords,
        },
        status: "draft",
        HSN: array[i]["Hsn"]
      }

      productData.push(piData);
    }
console.log(productData);
    setUploadProdCount(productData.length);

    api.product
      .addNewProductBulk(productData)
      .then((res) => {
        setUploadStart(false);
        setUploadError(false);
        setUploadSuccess(true);
        //   alert.success("Products added successfully");
        window.location.assign("/my-inventory/new_product_request/drafted");
      })
      .catch((err) => {
        console.log(err);
        setUploadStart(false);
        setUploadError(true);
        setUploadSuccess(false);
      });
  }
  const handleDownload = () => {
    const fileUrl = "./productsSample.xlsx"; // Replace with your local file URL
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "productsSample.xlsx"; // Specify the desired filename
    link.click();
  };
  const toggleCategoryFunc = () => {
    setToggleCategory(!toggleCategory);
    setCatNavToggleState("");
    setsubCatNavToggleState("");
  }
  const selectCategoryFunction = (name,targetId) => {
    setCategorySelected(true);
    setToggleCategory(!toggleCategory);
    setSelectedUploadCategory(name);
    let cats=getAllParents(categories, targetId);
    setFinalCategoryArray(cats);
  };
  // function getAllParents(data, targetId,  parentIds = []) {
    // Recursive function to find all parent IDs of a given _id
const getAllParents = (categories, targetId, parentIds = []) => {
  for (const category of categories) {
    if (category._id === targetId) {
      return [...parentIds, category._id];
    }
    if (category.subCategories) {
      const found = getAllParents(category.subCategories, targetId, [
        ...parentIds,
        category._id,
      ]);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

  // useEffect(()=>{

  //   const targetId = "5d6045625012501e0c6f6b5b";
  //   const parentIds = getAllParents(categories, targetId);
  //   console.log(parentIds);
  // },[categories])
// getAllParents("5d6045625012501e0c6f6b5a");  
const setSelectedUploadCategoryfunc=(categoryname,targetId)=>{
  setSelectedUploadCategory(categoryname);
  let cats=getAllParents(categories, targetId);
  setFinalCategoryArray(cats);
}
  return (
    <>
      <div className="bulkuploadprod">
        <div className="upload-but">
          <div className="text"></div>
          <div className="relative">
            {!uploadStart ? (
              <>
                {!categorySelected ? (
                  <label
                    className="button file-upload"
                    onClick={() => toggleCategoryFunc()}
                  >
                    <img src="/upload.webp" alt="upload" />
                    Bulk Upload
                  </label>
                ) : (
                  <label className="selected-category-box">
                    <div className="title">Selected Sub-Category :</div>
                    <div className="category">{selectedUploadCategory}</div>
                    <div className="action-buttons">
                      <div
                        className="back"
                        onClick={() => setCategorySelected(false)}
                      >
                        Back
                      </div>
                      <div
                        className="upload-file  file-upload"
                        htmlFor="file-upload-input"
                      >
                        <img src="/upload.webp" alt="upload" />
                        Upload File
                        <input
                          id="file-upload-input"
                          onChange={(event) => uploadData(event)}
                          type="file"
                        />
                      </div>
                    </div>
                  </label>
                )}
                {toggleCategory && (
                  <div className="category-drop-down">
                    <ul className="category">
                      {categories &&
                        categories.map((category, index) => {
                          return (
                            <li className="main-category">
                              <div
                                className={`category-inner  ${ catNavToggleState == category.categoryName ? 'active' :'' }`}
                                onClick={() => {
                                  setCatNavToggleState(
                                    catNavToggleState == category.categoryName
                                      ? ""
                                      : category.categoryName
                                  );
                                }}
                              >
                                {category.categoryName}
                                {category.subCategories.length ? (catNavToggleState == category.categoryName?<img src="/right-arrow-white.webp" alt="right-arrow" />:<img src="/right-arrow.webp" alt="right-arrow" />):''}
                              </div>
                              {catNavToggleState == category.categoryName && (
                                <>
                                  {category.subCategories && (
                                    <ul className="subcategory level1" key={index}>
                                      {category?.subCategories.map(
                                        (subcategory, index1) => {
                                          return (
                                            <li
                                              className="sub-category"
                                              key={index1}
                                            >
                                              <div
                                                className={`category-inner  ${ subCatNavToggleState == subcategory.categoryName ? 'active' :'' }`}
                                                onClick={() => {
                                                  subcategory.subCategories
                                                    ?.length
                                                    ? setsubCatNavToggleState(
                                                        subCatNavToggleState ==
                                                          subcategory.categoryName
                                                          ? ""
                                                          : subcategory.categoryName
                                                      )
                                                    : selectCategoryFunction(
                                                        subcategory.categoryName,
                                                        subcategory._id
                                                      );
                                                }}
                                              >
                                                {subcategory.categoryName}
                                                {subcategory.subCategories.length ? (subCatNavToggleState == subcategory.categoryName?<img src="/right-arrow-white.webp" alt="right-arrow" />:<img src="/right-arrow.webp" alt="right-arrow" />):''}
                                              </div>
                                              {subCatNavToggleState ==
                                                subcategory?.categoryName && (
                                                <>
                                                  {subcategory?.subCategories && (
                                                    <ul className="subcategory level2">
                                                      {subcategory?.subCategories.map(
                                                        (
                                                          subcategory1,
                                                          index2
                                                        ) => {
                                                          return (
                                                            <li
                                                              key={index2}
                                                              onClick={() => {
                                                                setCategorySelected(
                                                                  true
                                                                );
                                                                setToggleCategory(
                                                                  !toggleCategory
                                                                );
                                                                setSelectedUploadCategoryfunc(
                                                                  subcategory1.categoryName,
                                                                  subcategory1._id,
                                                                );
                                                              }}
                                                              className="sub-category"
                                                            >
                                                              <div className="category-inner">
                                                                {
                                                                  subcategory1.categoryName
                                                                }
                                                              </div>
                                                            </li>
                                                          );
                                                        }
                                                      )}
                                                    </ul>
                                                  )}
                                                </>
                                              )}
                                            </li>
                                          );
                                        }
                                      )}
                                    </ul>
                                  )}
                                </>
                              )}
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="button button-disabled">
                  <img src="/disabled-upload.webp" alt="upload" />
                  Bulk Upload
                </div>
                <div className="file-Processing">
                  <div className="custom-loader"></div>
                  <div className="precessing">Uploading...</div>
                  <div className="file-name">Product.xlsx</div>
                </div>
              </>
            )}
            {uploadSuccess && (
              <div className="upload-success">
                {uploadProdCount} Product Uploaded Successfully
              </div>
            )}
            {uploadError && (
              <div className="upload-failed">Processing Failed</div>
            )}
          </div>
          <div>
            <label className="button" onClick={handleDownload}>
              <img src="/download.webp" alt="upload" />
              Download Sample File
            </label>
          </div>
        </div>
        <div className="instructions-grid">
          <div className="video-box">
            <div className="text">How to use bulk upload?</div>
            <div className="inst-video">
              {/* <img src="/video.png" alt="video" /> */}
              <iframe src="https://player.vimeo.com/video/849059662?badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen" style={{width:"400px", height:"240px"}} title="Bulk upload"></iframe><script src="https://player.vimeo.com/api/player.js"></script>
              

            </div>
          </div>
          <div className="instruction">
            <div className="heading">Instruction:</div>
            <div className="inst-text">
              <p>
                <span>Step 1:</span> Download the sample file from the “Download
                Sample File” Option
              </p>
              <p>
                <span>Step 2:</span> Edit the excel file using Excel file
                editor. (Microsoft Excel Recommended )
              </p>
              <p>
                <span>Step 3:</span> Fill all the Column as per the heading.
                (Please refer to the video)
              </p>
              <p>
                <span>Step 4:</span> Save the file. (Each row’s data will take
                as a single product’s data){" "}
              </p>
              <p>
                <span>Step 5:</span> Upload the excel file using “Upload file”
                option{" "}
              </p>
              <p>
                <span>Step 6:</span> Add Image & Video from “Drafted Product”
                Section
              </p>
              <p>
                <span>Step 7:</span> After Adding all the necessary fields, Send
                request to Toolsvilla
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BulkUploadProd;
